import { Injectable, signal, TemplateRef } from '@angular/core';

export interface PageBarTab {
  id:        string;
  label:     string;
  dataAttr?: string;
}

export interface PageBarConfig {
  label?:           string;
  backLabel?:       string;
  tabs?:            PageBarTab[];
  activeTabId?:     string;
  onTabClick?:      (tab: PageBarTab) => void;
  onBack?:          () => void;
  actionsTemplate?: TemplateRef<any> | null;
}

@Injectable({ providedIn: 'root' })
export class PageBarService {

  private _config = signal<PageBarConfig>({});
  readonly config = this._config.asReadonly();

  set(config: PageBarConfig): void {
    this._config.set(config);
  }

  setLabel(label: string): void {
    this._config.update(c => ({ ...c, label }));
  }

  setTabs(tabs: PageBarTab[]): void {
    // Reset l'onglet actif au premier tab quand les tabs changent
    this._config.update(c => ({ ...c, tabs, activeTabId: tabs[0]?.id }));
  }

  setActiveTab(id: string): void {
    this._config.update(c => ({ ...c, activeTabId: id }));
  }

  setActionsTemplate(template: TemplateRef<any> | null): void {
    this._config.update(c => ({ ...c, actionsTemplate: template }));
  }

  reset(): void {
    this._config.set({});
  }
}